export default __webpack_public_path__ + "static/media/Opportunities.4d48506b.svg";